function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 0.128,
  y1: 0.433,
  x2: 0.946,
  y2: 0.786,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1bd1f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1597ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: -1.061,
  y1: 0.838,
  x2: 1.941,
  y2: 0.898,
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: -0.736,
  y1: 0.929,
  x2: 2.215,
  y2: 1.043,
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("filter", {
  id: "h",
  x: 0,
  y: 0,
  width: 149,
  height: 91.534,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.149
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1",
  transform: "translate(-513 -432)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(513 432)",
  filter: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 26",
  d: "M582.484 450.256c29.453 0 53.693 23.976 56.727 54.75a7.06 7.06 0 006.87 6.529 7.213 7.213 0 006.881-8.151C649.339 466.607 621.489 438 587.67 438c-35.723 0-64.786 31.92-65.669 71.671a1.784 1.784 0 001.732 1.864 1.777 1.777 0 001.728-1.773c.873-33.024 26.069-59.506 57.023-59.506z",
  transform: "translate(-513 -432)",
  fill: "url(#g)"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 27",
  d: "M617.607 535.809c-2.257 3.6-1.389 8.207 1.938 10.294s7.855.864 10.112-2.734S649.725 498 649.725 498s-29.861 34.212-32.118 37.809zm11.86 4.531c-1.818 2.9-5.319 3.978-7.818 2.41s-3.051-5.189-1.231-8.087 25.549-30.673 25.549-30.673-14.681 33.451-16.5 36.35z",
  transform: "rotate(-5.13 284.555 959.934)",
  fill: "#56d2f7"
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 94",
  width: 0.936,
  height: 11.229,
  rx: 0.468,
  transform: "rotate(17.356 -1273.9 2227.756)",
  fill: "url(#i)"
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 95",
  width: 0.936,
  height: 5.874,
  rx: 0.468,
  transform: "rotate(16.356 -1383.864 2355.242)",
  fill: "url(#k)"
}));

var SvgPerformance = function SvgPerformance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-performance",
    viewBox: "0 0 149 91.534",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerformance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/performance.0378f841.svg";
export { ForwardRef as ReactComponent };